import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from "@components/custom/Search";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchConductorsComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;

  const inputs = [{
    name: "supplier_id",
    label: <FormattedMessage id="app.supplier" defaultMessage={`Supplier`}/>,
    type: SearchInputType.SUPPLIER,
    size : 8
  },{
    name: "from",
    label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
    type: SearchInputType.DATE,
    size: 8
  }, {
    name: "to",
    label: <FormattedMessage id="app.to" defaultMessage={`To`}/>,
    type: SearchInputType.DATE,
    size: 8
  }];
  
  return <Search inputs={inputs} search={search}/>
  
};

export default SearchConductorsComponent;